import { render, staticRenderFns } from "./logo-image.vue?vue&type=template&id=a9befdba&scoped=true"
import script from "./logo-image.vue?vue&type=script&lang=js"
export * from "./logo-image.vue?vue&type=script&lang=js"
import style0 from "./logo-image.vue?vue&type=style&index=0&id=a9befdba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9befdba",
  null
  
)

export default component.exports